import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as  API from "../../../utils/apiPath";

// ==========================
//  Load Resource Hub Data
// ==========================
export const loadResourcesHubData = createAsyncThunk(
    "resourcesHub/loadResourcesHubData",
    async (request, { rejectWithValue }) => {
        try {
            // Same as old code (POST + category param)
            const response = await agent.post(
                `${API.RESOURCES_HUB_DATA}/${request.category}`,
                { params: request }
            );

            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to load resources"
            );
        }
    }
);

// ==========================
//  Load Setting (module_data)
// ==========================
export const loadSettingData = createAsyncThunk(
    "resourcesHub/loadSettingData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.SETTING);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to load settings");
        }
    }
);

export const postResourcesHubData = createAsyncThunk(
    "resourcesHub/postResourcesHubData",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await agent.post(API.SAVE_RESOURCES_HUB, formData, {
                headers: {
                    "Content-Type": undefined, // keep same behavior
                },
            });

            // Return full server response like old code
            return response.data;

        } catch (error) {
            return rejectWithValue({
                status: error?.response?.status || 500,
                message: error?.response?.data?.message || "An unexpected error occurred.",
            });
        }
    }
);


// ==========================
//  Slice
// ==========================
const resourcesHubSlice = createSlice({
    name: "resourcesHub",
    initialState: {
        resources: [],
        loadingResources: false,
        resourcesError: null,
        setting: null,
        loadingSetting: false,
        settingError: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        // =================================
        // Load Resources Hub Data
        // =================================
        builder
            .addCase(loadResourcesHubData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadResourcesHubData.fulfilled, (state, action) => {
                state.loading = false;
                state.resources = action.payload;
            })
            .addCase(loadResourcesHubData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // =================================
            // Load Settings
            // =================================
            .addCase(loadSettingData.pending, (state) => {
                state.loadingSetting = true;
                state.settingError = null;
            })
            .addCase(loadSettingData.fulfilled, (state, action) => {
                state.loadingSetting = false;
                state.setting = action.payload;
            })
            .addCase(loadSettingData.rejected, (state, action) => {
                state.loadingSetting = false;
                state.settingError = action.payload;
            })
            .addCase(postResourcesHubData.pending, (state) => {
                state.submitting = true;
                state.error = null;
            })
            // === submittingRequestStatus(false) + return response
            .addCase(postResourcesHubData.fulfilled, (state, action) => {
                state.submitting = false;
                state.response = action.payload;
            })
            // === submittingRequestStatus(false) + return error object
            .addCase(postResourcesHubData.rejected, (state, action) => {
                state.submitting = false;
                state.error = action.payload;
            });
    },
});

export default resourcesHubSlice.reducer;
